import React from 'react'
import { Box, Skeleton, Stack, Divider } from '@mui/material'

const CardLoading = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 2
      }}
    >
      {Array.from({ length: 3 }).map((_, i) => (
        <Box
          sx={{
            border: '1px solid #e0e0e0',
            borderRadius: 2,
            p: 2,
            width: '100%',
            maxWidth: 500,
            backgroundColor: '#ffffff'
          }}
        >
          <Skeleton
            variant='text'
            width={300}
            height={40}
            sx={{
              fontSize: '1.5rem',
              mb: 2,
              mx: 'auto',
              textAlign: 'center'
            }}
          />

          <Box sx={{ mb: 2 }}>
            {[
              'Total Claims',
              'Total Discount Amount',
              'Total Net Amount',
              'Total Quantity'
            ].map((item, index) => (
              <Box
                key={index}
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  mb: 1,
                  alignItems: 'center'
                }}
              >
                <Skeleton variant='text' width={160} height={25} />
                <Skeleton variant='text' width={60} height={25} />
              </Box>
            ))}
          </Box>

          <Divider sx={{ my: 2 }} />

          <Stack direction='row' spacing={2} justifyContent='center'>
            <Skeleton variant='rounded' width={120} height={36} />
            <Skeleton variant='rounded' width={80} height={36} />
            <Skeleton variant='rounded' width={100} height={36} />
          </Stack>
        </Box>
      ))}
    </Box>
  )
}

export default CardLoading
